export const LIST = "PARCEL_LISTING";
export const DROPDOWN = "PARCEL_DROPDOWN";
export const DETAILS = "PARCEL_DETAILS";
export const UPDATE = "PARCEL_UPDATE";
export const SYSALERT = "PARCEL_SYSALERT";
